<template>
  <div class="full-width">
    <div class="input">
      <label>Habit Program</label>
      <select
        v-model="data.habit_program"
        @change="getAreasOfFocus"
        :disabled="!user.has_coach_license"
      >
        <option v-for="program in habitPrograms" :value="program.id" :key="program.id">
          {{program.name}}
        </option>
      </select>
    </div>
    <div class="error-msg" v-if="error">
      You have duplicate areas of focus
    </div>
    <div v-if="current_program.id && !current_program.assign_all" class="input">
      <label>Areas Of Focus</label>
      <select-aof 
        :program="current_program"
        :data="data"
        :areas="areas"
        @areasOfFocusUpdated="areasOfFocusUpdated" />
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import selectAof from "./selectAoF";

const HABIT_PROGRAM_STORE = "ClientHabitPrograms";
const AREA_OF_FOCUS_STORE = "ClientAreasOfGrowth";

export default {
  props: { 
    user: Object,
    data: Object,
    habitStore: {
      type: String,
      default: HABIT_PROGRAM_STORE
      },
    areasStore: {
      type: String,
      default: AREA_OF_FOCUS_STORE
      }
   },
  components: {
    selectAof
  },
  data() {
    return {
      habitPrograms: [],
      error: false,
      current_program: {
        assign_all: true
      },
      areas: []
    };
  },
  created() {
    dataStore
      .findAll(this.habitStore, { limit: 500 }, { force: true })
      .then(r => {
        console.log(r)
        this.habitPrograms = r;
      });

    this.areas_of_focus = this.user.groups;
    this.data.areas_of_focus = (this.user.groups || []).map(i => i);
    this.data.habit_program = this.user.theme;
    dataStore.find(this.habitStore, this.user.theme).then(habitProgram => {
      this.current_program = habitProgram;
    });

    dataStore
      .findAll(
        this.areasStore,
        { areas_of_focus: this.user.theme },
        { force: true }
      )
      .then(r => {
        this.areas = r;
      });
  },
  methods: {
    areasOfFocusUpdated() {
      this.error =
        new Set(this.data.areas_of_focus).size !==
        this.data.areas_of_focus.length;
    },
    getAreasOfFocus() {
      this.areas_of_focus = [];
      this.data.areas_of_focus = [];
      dataStore
        .findAll(
          this.areasStore,
          { areas_of_focus: this.data.habit_program },
          { force: true }
        )
        .then(r => {
          this.areas = r;
        });
      dataStore
        .find(this.habitStore, this.data.habit_program, { force: true })
        .then(habitProgram => {
          this.current_program = habitProgram;
        });
    }
  }
};
</script>
